
import React, {Component} from 'react'
import {Modal} from 'react-bootstrap'
import PurchaseOrderDoc from './PurchaseOrderDoc'
class PurchaseOrderDocModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false,poNo:''}
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.show && newProps.show!==this.props.show)
  //     this.loadRecord()
  // }

  loadData(poNo){
    this.setState({show:true,poNo:poNo})    
    setTimeout(()=>{
      
    },500)
    //this.refs.poDoc.loadData(poNo)
  }

  onShow(){
    const {poNo} = this.state
    this.refs.poDoc.getWrappedInstance().loadData(poNo)
  }

  onHide(){
    this.setState({show:false})
  }

  render(){
    let {show} = this.state
    
    return (
      <div>        
        <Modal 
            show={show}
            onShow={this.onShow.bind(this)}
            onHide={this.onHide.bind(this)}
            enforceFocus={false}
            dialogClassName="fullwidth-dialog"
        >
          <Modal.Body>              
              <PurchaseOrderDoc 
                  ref='poDoc'   
                  closeButton={true}                                                       
                  onClose={this.onHide.bind(this)}
              />
          </Modal.Body>   
        </Modal>  
      </div>
    )
  }
}

PurchaseOrderDocModal.defaultProps = {
  show: false,
  poNo: '',
  onHide:()=>{}
}


export default PurchaseOrderDocModal;








// WEBPACK FOOTER //
// ./src/view/po/PurchaseOrderDocModal.js